import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  Dialog,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Divider,
  IconButton,
  ListItemIcon,
  Collapse,
  DialogActions,
  Button,
  Checkbox,
  Typography,
  FormControlLabel,
} from "@material-ui/core";
import * as React from "react";
import { colors } from "../constants/constants";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import CheckIcon from "@material-ui/icons/Check";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import DeleteIcon from "@material-ui/icons/Delete";
import CloseIcon from "@material-ui/icons/Close";
import GenericDialog from "./GenericDialog";
import { types } from "./AddCompanyDialog";
const drawerWidth = 340;
const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      padding: 3,
    },
    button: {
      margin: theme.spacing(1),
      width: "30%",
      height: 48,
    },
    paper: {
      padding: theme.spacing(1) * 2,
      textAlign: "center",
      height: "100%",
      color: theme.palette.text.secondary,
    },
    control: {
      padding: theme.spacing(1) * 2,
    },
    appBar: {
      [theme.breakpoints.up("sm")]: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
      },
    },
    menuHideButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "none",
      },
    },
    margin: {
      margin: theme.spacing(1),
    },
    menuShowButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "visible",
      },
      color: "black",
    },
    extendedIcon: {
      marginRight: theme.spacing(1),
    },
    sectionDesktop: {
      display: "none",
      [theme.breakpoints.up("md")]: {
        display: "flex",
      },
    },
    avatar: {
      backgroundColor: colors.primaryColor,
      color: "#ffff",
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      paddingTop: 0,
      paddingBottom: 8,
      minHeight: 64,
    },
    nested: {
      paddingLeft: theme.spacing(4),
    },
    drawerPaper: {
      width: drawerWidth,
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    large: {
      margin: 10,
      width: theme.spacing(15),
      height: theme.spacing(15),
    },
    tickAllButton: {
      position: "absolute",
      right: theme.spacing(2),
      top: theme.spacing(2),
      color: theme.palette.grey[500],
    },
    rootTitle: {
      margin: 0,
      padding: theme.spacing(2),
    },
  });
interface Props extends WithStyles<typeof styles> {
  open: any;
  dialogTitle: any;
  data: any;
  onClose: any;
  renderDialog?: any;
  tickAll?: any;
  handleOnDeleteAllClicked?: any;
}
class ListItemDialog extends React.Component<Props> {
  state = {
    openMore: [{ index: 0, open: false }],
    deleteAll: false,
    showConfirmationDeleteAllDialog: false,
  };
  handleClose = () => {
    this.setState(
      {
        deleteAll: false,
      },
      () => {
        this.props.onClose();
      }
    );
  };
  handleClick = (index: any) => {
    let openMoreArray = this.state.openMore;
    let isOpen = !openMoreArray[index].open;
    openMoreArray[index].open = isOpen;
    this.setState({
      openMore: openMoreArray,
    });
  };
  handleListItemClick = () => {
    this.props.onClose();
  };

  componentDidMount = () => {
    const { data } = this.props;
    let openMoreArray = Array<any>();
    data.map((index: any) => {
      openMoreArray.push({ index: index, open: false });
      return null;
    });
    this.setState({
      openMore: openMoreArray,
    });
  };

  componentDidUpdate = (prevProps: any, prevState: any) => {
    const { data } = this.props;
    if (data !== prevProps.data) {
      let openMoreArray = Array<any>();
      data.map((index: any) => {
        openMoreArray.push({ index: index, open: false });
        return null;
      });
      this.setState({
        openMore: openMoreArray,
      });
    }
  };

  renderActionedInspectionDeleteAllConfirmationDialog = () => {
    const { handleOnDeleteAllClicked } = this.props;
    let contentMessage = {
      title: "Deleting all actioned inspections",
      message: "Are you sure you want to delete all the Actioned Inspection?",
    };
    return (
      <GenericDialog
        type={types.DIALOG_INFO}
        title={contentMessage.title}
        message={contentMessage.message}
        leftButtonName={"Cancel"}
        rightButtonName={"YES"}
        open={this.state.showConfirmationDeleteAllDialog}
        onCancel={() =>
          this.setState({ showConfirmationDeleteAllDialog: false })
        }
        onOk={() =>
          this.setState(
            {
              showConfirmationDeleteAllDialog: false,
              tickAll: false,
            },
            () => {
              handleOnDeleteAllClicked();
            }
          )
        }
        handleClose={() =>
          this.setState({ showConfirmationDeleteAllDialog: false })
        }
      />
    );
  };

  render() {
    const {
      open,
      data,
      dialogTitle,
      tickAll,
      classes,
      renderDialog,
    } = this.props;
    return (
      <Dialog
        onClose={() => this.handleClose()}
        aria-labelledby="simple-dialog-title"
        open={open}
        maxWidth={renderDialog ? "md" : "sm"}
        fullWidth
      >
        <React.Fragment>
          {/* <DialogTitle id="simple-dialog-title">{dialogTitle}</DialogTitle>
          <Checkbox
            defaultChecked
            size="small"
            inputProps={{ "aria-label": "checkbox with small size" }}
          /> */}
          <MuiDialogTitle disableTypography className={classes.rootTitle}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography variant="h6">{dialogTitle}</Typography>
              {tickAll ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    marginRight: 5,
                  }}
                  className={classes.tickAllButton}
                >
                  {!this.state.deleteAll ? (
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.deleteAll}
                          onChange={(event: any) => {
                            this.setState({
                              deleteAll: event.target.checked,
                            });
                          }}
                          name="checkedB"
                          color="primary"
                        />
                      }
                      label="Delete All"
                    />
                  ) : (
                      <IconButton
                        aria-label="delete"
                        className={classes.margin}
                        size="small"
                        onClick={() =>
                          this.setState({
                            deleteAll: false,
                          })
                        }
                      >
                        <CloseIcon />
                      </IconButton>
                    )}

                  {this.state.deleteAll && (
                    <IconButton
                      aria-label="delete"
                      className={classes.margin}
                      size="small"
                      onClick={() =>
                        this.setState({
                          deleteAll: false,
                          showConfirmationDeleteAllDialog: true,
                        })
                      }
                    >
                      <DeleteIcon />
                    </IconButton>
                  )}
                </div>
              ) : null}
            </div>
          </MuiDialogTitle>
          <Divider />
          {data && data.length > 0 && (
            <List>
              {data.map((item: any, index: any) => (
                <React.Fragment key={index.toString()}>
                  <ListItem>
                    <ListItemAvatar>
                      <Avatar className={classes.avatar}>{item.icon}</Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={item.option}
                      secondary={item.subtitle}
                    />
                    {item.action && item.action.type === "text" && (
                      <ListItemText
                        primary={item.action.title}
                        style={{ direction: "rtl", textAlign: "right" }}
                      />
                    )}
                    {item.action && item.action.type === "more" && (
                      <IconButton
                        aria-label="delete"
                        className={classes.margin}
                        size="small"
                        onClick={() => this.handleClick(index)}
                      >
                        {this.state.openMore &&
                          this.state.openMore[index] &&
                          this.state.openMore[index].open &&
                          this.state.openMore ? (
                            <ExpandLess />
                          ) : (
                            <ExpandMore />
                          )}
                      </IconButton>
                    )}
                    {item.action && item.action.type === "delete" && (
                      <div>
                        {!this.state.deleteAll ? (
                          item.action.renderIconAction
                        ) : (
                            <IconButton
                              aria-label="delete"
                              className={classes.margin}
                              size="small"
                            >
                              <CheckIcon />
                            </IconButton>
                          )}
                      </div>
                    )}
                  </ListItem>
                  {item.action &&
                    item.action.data &&
                    this.state.openMore &&
                    this.state.openMore[index] &&
                    this.state.openMore[index].open && (
                      <Collapse
                        in={this.state.openMore[index].open}
                        timeout="auto"
                        unmountOnExit
                      >
                        <List component="div" disablePadding>
                          {item.action.data.map((itemData: any) => (
                            <ListItem button className={classes.nested}>
                              <ListItemIcon>{item.action.icon}</ListItemIcon>
                              <ListItemText
                                primary={itemData.title}
                                secondary={itemData.subtitle}
                              />
                            </ListItem>
                          ))}
                        </List>
                      </Collapse>
                    )}
                </React.Fragment>
              ))}
            </List>
          )}
          {renderDialog}
          <DialogActions>
            <Button onClick={() => this.handleClose()}>{"Close"}</Button>
          </DialogActions>
          {this.renderActionedInspectionDeleteAllConfirmationDialog()}
        </React.Fragment>
      </Dialog>
    );
  }
}
export default withStyles(styles)(ListItemDialog);
